(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-engraving"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-engraving-component')) {
    class ProductEngraving extends HTMLElement {
      connectedCallback() {
        this.state = this.state || { on: false, text: '', text2: '', sides: 'One side', font: 'Classic' };
        if (!this._bound) {
          this._bound = true;
          this.addEventListener('change', (e) => this.onChange(e));
          this.addEventListener('input', (e) => this.onInput(e));
          this._onSubmit = (e) => this.onSubmit(e);
          this._onVariant = (e) => this.onVariant(e);
          this._observer = new MutationObserver(() => this.sync());
          this._scopeObserver = new MutationObserver(() => this.onScope());
        }
        window.addEventListener('submit', this._onSubmit, true);
        document.addEventListener('variant:update', this._onVariant);
        this.sync();
      }

      disconnectedCallback() {
        window.removeEventListener('submit', this._onSubmit, true);
        document.removeEventListener('variant:update', this._onVariant);
        if (this._observer) this._observer.disconnect();
        if (this._scopeObserver) this._scopeObserver.disconnect();
      }

      q(sel) {
        return this.querySelector(sel);
      }

      get scope() {
        return this.closest('.shopify-section') || document;
      }

      get max() {
        const root = this.q('[data-engr]');
        return parseInt(root ? root.dataset.max : '', 10) || 20;
      }

      get variantMode() {
        const root = this.q('[data-engr]');
        return !!root && root.dataset.variantMode === 'true';
      }

      get isBoth() {
        if (this.variantMode) return this.state.sides === 'Both sides';
        return !!this.q('[data-engr-side]') && this.state.sides === 'Both sides';
      }

      readJson(sel) {
        const el = this.q(sel);
        try {
          return el ? JSON.parse(el.textContent) : {};
        } catch (err) {
          return {};
        }
      }

      get prices() {
        if (!this._prices) this._prices = this.readJson('[data-engr-prices]');
        return this._prices;
      }

      get variants() {
        if (!this._variants) this._variants = this.readJson('[data-engr-variants]');
        return this._variants;
      }

      currentVariantId() {
        if (this._eventVariantId) return this._eventVariantId;
        const root = this.q('[data-engr]');
        if (!root) return '';
        const form = document.getElementById(root.dataset.formId);
        const idInput = form ? form.querySelector('[name=id]') || form.elements.namedItem('id') : null;
        if (idInput && idInput.value) return String(idInput.value);
        return root.dataset.currentVariant || '';
      }

      classify(value) {
        const v = String(value || '').toLowerCase();
        if (!v) return 'off';
        if (/\bno\b|none|without|plain/.test(v)) return 'off';
        if (/2|both|double|two/.test(v)) return 'both';
        return 'one';
      }

      onVariant(e) {
        if (!this.variantMode) return;
        if (e.target && e.target.nodeType === 1 && !this.scope.contains(e.target)) return;
        const resource = e.detail && e.detail.resource;
        if (resource && resource.id) this._eventVariantId = String(resource.id);
        this.sync();
        setTimeout(() => this.sync(), 150);
      }

      onScope() {
        if (this.variantMode) {
          if (this.currentVariantId() !== this._lastVariantId) this.sync();
        } else {
          this.applyPrice();
        }
      }

      clean(value) {
        return value
          .replace(/[^\p{L}\p{N} .,'&!?\-]/gu, '')
          .replace(/^\s+/, '')
          .slice(0, this.max);
      }

      onChange(e) {
        const t = e.target;
        if (t.matches('[data-engr-choice]')) {
          if (!t.checked) return;
          this.state.on = t.value === 'on';
          this._error = false;
          this._fail = false;
          this.sync();
          if (this.state.on) {
            const input = this.q('[data-engr-text]');
            if (input) input.focus();
          }
        } else if (t.matches('[data-engr-side]') && t.checked) {
          this.state.sides = t.value;
          this.sync();
        } else if (t.matches('[data-engr-font]') && t.checked) {
          this.state.font = t.value;
          this.sync();
        }
      }

      onInput(e) {
        const t = e.target;
        if (t.matches('[data-engr-text]')) {
          this.state.text = this.clean(t.value);
          this._error = false;
        } else if (t.matches('[data-engr-text2]')) {
          this.state.text2 = this.clean(t.value);
        } else {
          return;
        }
        this.sync();
      }

      applyPrice() {
        const root = this.q('[data-engr]');
        if (!root || !root.dataset.addonOne) return;
        const entry = this.prices[this.currentVariantId()];
        if (!entry) return;
        const s = this.state;
        if (!s.on && !this._priceTouched) return;
        const text = !s.on ? entry[0] : this.isBoth ? entry[2] : entry[1];
        const scope = this.scope;
        this._scopeObserver.disconnect();
        scope.querySelectorAll('[ref=priceContainer] .price').forEach((el) => {
          if (el.closest('product-card')) return;
          if (el.textContent.trim() !== text) el.textContent = text;
        });
        this._priceTouched = s.on;
        this._scopeObserver.observe(scope, { subtree: true, childList: true, characterData: true });
      }

      resubmit(form, submitter) {
        this._pass = true;
        try {
          if (submitter) {
            form.requestSubmit(submitter);
          } else {
            form.requestSubmit();
          }
        } catch (err) {
          try {
            form.requestSubmit();
          } catch (err2) {
            this._pass = false;
            form.submit();
          }
        }
      }

      onSubmit(e) {
        const root = this.q('[data-engr]');
        const form = e.target;
        if (!root || !form || form.id !== root.dataset.formId) return;
        const s = this.state;
        if (!s.on) return;

        if (!s.text.trim()) {
          e.preventDefault();
          e.stopPropagation();
          this._error = true;
          this.sync();
          const input = this.q('[data-engr-text]');
          if (input) input.focus();
          return;
        }

        const variantId = this.isBoth ? root.dataset.addonBoth : root.dataset.addonOne;
        if (!variantId) return;

        if (this._pass) {
          this._pass = false;
          return;
        }

        e.preventDefault();
        e.stopPropagation();
        if (this._busy) return;
        this._busy = true;
        this._fail = false;

        const submitter = e.submitter || null;
        const quantity = parseInt(new FormData(form).get('quantity'), 10) || 1;
        const properties = { 'For': root.dataset.productTitle || '', 'Engraving': s.text };
        if (this.isBoth && s.text2.trim()) properties['Engraving side 2'] = s.text2;
        const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

        fetch(base + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity, properties: properties }] }),
        })
          .then((response) => {
            if (!response.ok) throw new Error('engraving add failed');
            this._busy = false;
            this.resubmit(form, submitter);
          })
          .catch(() => {
            this._busy = false;
            this._fail = true;
            this.sync();
          });
      }

      sync() {
        this._observer.disconnect();
        const s = this.state;
        const root = this.q('[data-engr]');
        const panel = this.q('[data-engr-panel]');
        const text = this.q('[data-engr-text]');
        if (root && panel && text) {
          const placeholder = root.dataset.placeholder || '';

          if (this.variantMode) {
            const id = this.currentVariantId();
            this._lastVariantId = id;
            const kind = this.classify(this.variants[id]);
            s.on = kind !== 'off';
            s.sides = kind === 'both' ? 'Both sides' : 'One side';
            if (!s.on) this._error = false;
            if (s.on) {
              root.removeAttribute('data-variant-off');
            } else {
              root.setAttribute('data-variant-off', '');
            }
          }

          const both = s.on && this.isBoth;

          this.querySelectorAll('[data-engr-choice]').forEach((choice) => {
            choice.checked = (choice.value === 'on') === s.on;
            if (choice.value === 'on') choice.setAttribute('aria-expanded', String(s.on));
          });
          panel.hidden = !s.on;
          text.disabled = !s.on;
          text.required = s.on;
          if (text.value !== s.text) text.value = s.text;

          const label = this.q('[data-engr-label]');
          if (label && root.dataset.labelBoth) {
            const labelText = both ? root.dataset.labelBoth : root.dataset.labelDefault;
            if (label.textContent !== labelText) label.textContent = labelText;
          }

          this.querySelectorAll('[data-engr-side]').forEach((radio) => {
            radio.disabled = !s.on;
            radio.checked = radio.value === s.sides;
          });
          const side2 = this.q('[data-engr-side2]');
          if (side2) side2.hidden = !both;
          const text2 = this.q('[data-engr-text2]');
          if (text2) {
            text2.disabled = !both;
            if (text2.value !== s.text2) text2.value = s.text2;
            if (both && s.text2.trim()) {
              text2.setAttribute('name', 'properties[' + (root.dataset.prop2 || 'Engraving side 2') + ']');
            } else {
              text2.removeAttribute('name');
            }
          }
          const count2 = this.q('[data-engr-count2]');
          if (count2) count2.textContent = s.text2.length + '/' + this.max;

          this.querySelectorAll('[data-engr-font]').forEach((radio) => {
            radio.disabled = !s.on;
            radio.checked = radio.value === s.font;
          });
          const count = this.q('[data-engr-count]');
          if (count) count.textContent = s.text.length + '/' + this.max;

          const preview = this.q('[data-engr-preview]');
          if (preview) {
            preview.textContent = s.text || placeholder;
            preview.dataset.font = s.font;
            preview.classList.toggle('is-empty', !s.text);
          }
          const plate2 = this.q('[data-engr-plate2]');
          if (plate2) plate2.hidden = !both;
          const preview2 = this.q('[data-engr-preview2]');
          if (preview2) {
            const second = s.text2 || s.text;
            preview2.textContent = second || placeholder;
            preview2.dataset.font = s.font;
            preview2.classList.toggle('is-empty', !second);
          }

          const fee = this.q('[data-engr-fee]');
          if (fee) fee.textContent = both ? fee.dataset.both : fee.dataset.one;

          if (root.dataset.addonOne) {
            this.scope.querySelectorAll('.shopify-payment-button').forEach((el) => {
              el.style.display = s.on ? 'none' : '';
            });
          }

          const error = this.q('[data-engr-error]');
          if (error) error.hidden = !this._error;
          const fail = this.q('[data-engr-fail]');
          if (fail) fail.hidden = !this._fail;
          this.classList.toggle('is-on', s.on);

          if (this.variantMode) {
            this._scopeObserver.disconnect();
            this._scopeObserver.observe(this.scope, { subtree: true, childList: true, attributes: true, attributeFilter: ['value', 'data-current-variant'] });
          }
        }
        this._observer.observe(this, { subtree: true, childList: true, attributes: true, characterData: true });
        if (!this.variantMode) this.applyPrice();
      }
    }
    customElements.define('product-engraving-component', ProductEngraving);
  }
  } catch(e) { console.error(e); }
})();

})();
